function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableclipboard
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableSelection from './tableselection';
/**
 * This plugin adds support for copying/cutting/pasting fragments of tables.
 * It is loaded automatically by the {@link module:table/table~Table} plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TableClipboard =
/*#__PURE__*/
function (_Plugin) {
  _inherits(TableClipboard, _Plugin);

  function TableClipboard() {
    _classCallCheck(this, TableClipboard);

    return _possibleConstructorReturn(this, _getPrototypeOf(TableClipboard).apply(this, arguments));
  }

  _createClass(TableClipboard, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var _this = this;

      var editor = this.editor;
      var viewDocument = editor.editing.view.document;
      this.listenTo(viewDocument, 'copy', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
      this.listenTo(viewDocument, 'cut', function (evt, data) {
        return _this._onCopyCut(evt, data);
      });
    }
    /**
     * Copies table content to a clipboard on "copy" & "cut" events.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} evt An object containing information about the handled event.
     * @param {Object} data Clipboard event data.
     */

  }, {
    key: "_onCopyCut",
    value: function _onCopyCut(evt, data) {
      var tableSelection = this.editor.plugins.get('TableSelection');

      if (!tableSelection.getSelectedTableCells()) {
        return;
      }

      if (evt.name == 'cut' && this.editor.isReadOnly) {
        return;
      }

      data.preventDefault();
      evt.stop();
      var dataController = this.editor.data;
      var viewDocument = this.editor.editing.view.document;
      var content = dataController.toView(tableSelection.getSelectionAsFragment());
      viewDocument.fire('clipboardOutput', {
        dataTransfer: data.dataTransfer,
        content: content,
        method: evt.name
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'TableClipboard';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableSelection];
    }
  }]);

  return TableClipboard;
}(Plugin);

export { TableClipboard as default };